import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class LoanService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getLoans(fundID, page, size, nationalCode, groupCode, groupName, accountCode, startDate, endDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/loans`,
                {
                    page, size,
                    groupCode,
                    "national-code": nationalCode,
                    "group-name": groupName,
                    "deposit-account-number": accountCode,
                    startDate,
                    endDate
                }
            ).then(resolve).catch(reject)
        })
    }

    getDetail(fundID, id) {
        const loanStatusRequest = this.httpClient.get(
            `funds/${fundID}/loans/${id}/details-status`,
        );

        const loanDetailRequest = this.httpClient.get(
            `funds/${fundID}/loans/${id}`,
        )

        const requestList = [loanStatusRequest, loanDetailRequest]

        return new Promise((resolve, reject) => {
            axios.all(requestList)
                .then(axios.spread((loanStatusResponse, loanDetailResponse) => {
                    resolve({
                        loanStatusResponse, loanDetailResponse
                    })
                })).catch(reject)
        })

    }

    uploadReceiptFile(fundID, id, file) {
        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).uploadFile(
                `${fundID}/loans/${id}/loan-receipts`,
                file
            ).then(resolve).catch(reject)
        })
    }

    getLoanReportFile(fundID, loanId, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.getFile(
                `funds/${fundID}/loans/${loanId}/reports/${type}`
            ).then(resolve).catch(reject)
        })
    }

    deleteLoan(fundID, loanId) {
        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `funds/${fundID}/loans/${loanId}?`
            ).then(resolve).catch(reject)
        })
    }

    getLoanKinds() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `loan-kinds`
            ).then(resolve).catch(reject)
        })
    }

    calculateLoanInstallments(fundID, depositAccountId, amount, numberOfInstallments, loanKindId, grantDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/loans/pre-create`,
                {
                    depositAccountId,
                    amount,
                    numberOfInstallments,
                    loanKindId,
                    grantDate
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewLoan(fundID, depositAccountId, amount, numberOfInstallments, loanKindId, grantDate, submitPaidForAll) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/loans`,
                {
                    depositAccountId,
                    amount,
                    numberOfInstallments,
                    loanKindId,
                    grantDate,
                    submitPaidForAll
                }
            ).then(resolve).catch(reject)
        })
    }
}